module.exports = __webpack_public_path__ + "static/media/press16.1c8d7d04.jpg";